<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYearmonth">
        {{ yearmonth }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchHourMonth"
        >
          <option :value="'物料'">物料</option>
          <option :value="'工作中心'">工作中心</option>
        </select>
      </span>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box">
      <search-bar
        v-if="querytype === '物料'"
        @search="searchHourMonth"
        name="pr_code,pr_detail,pr_orispeccode,pr_brand"
        placeholder="输入物料进行查找"
        ref="searchBar"
      />
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="(item, index) in result.details"
          :key="index"
          @click="initChart(deal2(item))"
        >
          <div class="weui-cell__bd">
            <p v-if="querytype === '物料'">
              {{ item.pr_code }} {{ item.pr_detail }}
            </p>
            <p v-if="querytype === '工作中心'">{{ item.wc_name }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.qty }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    SearchBar,
  },
  data() {
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let yearmonth = "" + year + (month < 10 ? "0" + month : month);

    return {
      result: {},
      yearmonth,
      querytype: "物料",
      querytypeObj: {
        物料: "prod",
        工作中心: "workcenter",
      },
      chart: null,
    };
  },
  mounted() {
    this.searchHourMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchHourMonth() {
      let me = this;

      let searchBar = me.$refs.searchBar;
      let keyword = searchBar && searchBar.keyword;

      const params = {
        yearmonth: me.yearmonth,
        querytype: me.querytypeObj[me.querytype],
      };
      if (keyword) {
        params.con = `(pr_code like '%${keyword}%' or pr_detail like '%${keyword}%' or pr_orispeccode like '%${keyword}%' or pr_brand like '%${keyword}%')`;
      }

      me.$ajax({
        url: "/api/make/report/makedisassemblehourMonth",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.dismonthitems));
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.dismonthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });
      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 21 : 12,
          formatter: (i) =>
            i > -1 && i < 31
              ? [
                  "1日",
                  "2日",
                  "3日",
                  "4日",
                  "5日",
                  "6日",
                  "7日",
                  "8日",
                  "9日",
                  "10日",
                  "11日",
                  "12日",
                  "13日",
                  "14日",
                  "15日",
                  "16日",
                  "17日",
                  "18日",
                  "19日",
                  "20日",
                  "21日",
                  "22日",
                  "23日",
                  "24日",
                  "25日",
                  "26日",
                  "27日",
                  "28日",
                  "29日",
                  "30日",
                  "31日",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "数量") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      
      chart.interaction("pan");

      chart.render();
    },
    deal(data) {
      if (!data) return;

      let arr = [
        { index: -1, type: "数量", value: 0 },
        { index: 31, type: "数量", value: 0 },
      ];

      for (let i = 0; i < 31; i++) {
        arr.push({
          text: data[i]?.text || "",
          type: "数量",
          index: i,
          value: data[i]?.qty || 0,
        });
      }

      return arr;
    },
    deal2(data) {
      if (!data) return;
      let arr = [
        { index: -1, type: "数量", value: 0 },
        { index: 31, type: "数量", value: 0 },
      ];
      
      for (let i = 0; i < 31; i++) {
        arr.push({
          index: i,
          text: i + "日",
          type: "数量",
          value: data["qty" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    onChangeChart(item) {
      let arr = [];
      for (let i = 0; i < item.days; i++) {
        arr[i] = {
          text: i + 1 + "日",
          day: i + 1,
          qty: item["qty" + (i + 1)] || 0,
        };
      }
      this.initChart(arr);
    },
    selectYearmonth() {
      var me = this,
        year = new Date().getFullYear(),
        years = [],
        months = [
          { value: "01", label: "1月" },
          { value: "02", label: "2月" },
          { value: "03", label: "3月" },
          { value: "04", label: "4月" },
          { value: "05", label: "5月" },
          { value: "06", label: "6月" },
          { value: "07", label: "7月" },
          { value: "08", label: "8月" },
          { value: "09", label: "9月" },
          { value: "10", label: "10月" },
          { value: "11", label: "11月" },
          { value: "12", label: "12月" },
        ];
      for (let i = year - 20, len = year + 20; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, months, {
        title: "选择年月",
        onConfirm: function (r) {
          me.yearmonth = r[0].value + r[1].value;
          me.searchHourMonth();
        },
      });
    },
  },
};
</script>

<style scoped>
.canvas-box {
  /* width: 200%; */
  overflow-x: scroll;
  /* height: 100%; */
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
@media screen and (min-width: 500px) {
  .filter-bar{
    padding: 6px 0 2px 0;
  }
  
}
</style>